import React, {useEffect} from 'react'
import {useLocation, Navigate} from 'react-router-dom'
import {useSelector} from 'react-redux'
import {RootState} from '@/setup'
import Login from './components/Login'
import ForgotPassword from './components/ForgotPassword'
import { getSelectedCompany } from './helpers/CompanyStorage'
import { getStoredAccessToken } from './helpers/TokenStorage'


/**
 * AuthPage Component - Hiển thị các trang authentication
 * 
 * QUY LUẬT 6: Auto-login Prevention
 * - Khi user đã authenticated và có selectedCompany:
 *   + Các trang auth (login, forgot-password) PHẢI redirect về /main
 *   + Không được hiển thị lại form login
 */
export function AuthPage() {
  const location = useLocation()
  const accessToken = useSelector((state: RootState) => state.auth.accessToken)
  const selectedCompany = useSelector((state: RootState) => state.auth.selectedCompany)
  const effectiveAccessToken = accessToken || getStoredAccessToken() || undefined
  const effectiveSelectedCompany = selectedCompany || getSelectedCompany()
  
  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])

  // QUY LUẬT 6: Redirect nếu user đã authenticated
  if (effectiveAccessToken && effectiveSelectedCompany) {
    return <Navigate to="/main" replace />
  }

  const renderContent = () => {
    if (location.pathname === '/login' || location.pathname === '/auth/login') {
      return <Login />
    }
    if (location.pathname === '/auth/forgot-password') {
      return <ForgotPassword />
    }
    return <Login />
  }

  return (
    <div>
      {renderContent()}
    </div>
  )
}
